import { Municipality } from "interfaces";
import { create } from "zustand";

interface Props {
  municipality: Municipality | null;
  setMunicipality: (municipality: Municipality | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  isOpenModal: boolean;
  setIsOpenModal: (state: boolean) => void;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  clearAll: () => void;
}

export const useMunicipalityStore = create<Props>((set, get) => ({
  municipality: null,
  setMunicipality: (municipality) => {
    set({ municipality: municipality });
  },
  isEdit: false,
  setIsEdit: (state) => {
    set({ isEdit: state });
  },
  isOpenModal: false,
  setIsOpenModal: (state) => {
    set({ isOpenModal: state });
  },
  handleOpenModal: () => {
    set({ isOpenModal: true });
  },
  handleCloseModal: () => {
    set({ isOpenModal: false });
  },
  clearAll: () => {
    set({
      municipality: null,
      isEdit: false,
      isOpenModal: false,
    });
  },
}));
